/* eslint-disable */
// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Rater.css';
import './Viewer.css';

const Navbar = () => {
    const [enabledDarkMode, setEnabledDarkMode] = useState(false);
    const selectEnabledDarkMode = () => {
        setEnabledDarkMode(!enabledDarkMode);
    }

    useEffect(() => {
        const root = document.documentElement;
        root.setAttribute('data-theme', enabledDarkMode ? "dark" : "light");
    }, [enabledDarkMode]);

    return(
        <nav>
            <NavLink to="/" end className="nav-button">Protocores</NavLink>
            <NavLink to="/memories" className="nav-button">Memories</NavLink>
            { enabledDarkMode ? 
                <button className="toggle-comment toggle-nav white-bg-color" onClick={selectEnabledDarkMode}>
                    <img className={`symbol-label-img symbol-label-lunar-img`} src={`/images/lunar.PNG`} alt="Lunar label" />
                    <div className="toggle-comment-container toggle-comment-true default-bg-color">
                        <div className="toggle-button"></div>
                    </div>
                </button>
                : <button className="toggle-comment toggle-nav white-bg-color" onClick={selectEnabledDarkMode}>
                    <img className={`symbol-label-img symbol-label-solar-img`} src={`/images/solar.PNG`} alt="Solar label" />
                    <div className="toggle-comment-container toggle-comment-false default-bg-color">
                        <div className="toggle-button"></div>
                    </div>
                </button>
            }
        </nav>
    );
}

export default Navbar;